(() => {
  const init = () => {
    setupReveal();
    setupHeaderShrink();
    setupMobileDrawer();
    setupCartCountUpdates();
    setupAccountDropdown();
  };

  const setupAccountDropdown = () => {
    const wrap = document.querySelector('[data-cherry-account]');
    if (!wrap) return;
    const trigger = wrap.querySelector('[data-cherry-account-trigger]');
    const menu = wrap.querySelector('[data-cherry-account-menu]');
    if (!trigger || !menu) return;

    const close = () => {
      menu.hidden = true;
      wrap.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    };
    const open = () => {
      menu.hidden = false;
      wrap.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    };

    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      if (menu.hidden) open(); else close();
    });

    document.addEventListener('click', (e) => {
      if (!menu.hidden && !wrap.contains(e.target)) close();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !menu.hidden) {
        close();
        trigger.focus();
      }
    });
  };

  const setupReveal = () => {
    const els = document.querySelectorAll('.cherry-reveal');
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach((el) => el.classList.add('is-visible'));
      return;
    }
    // Lo que ya está en pantalla se muestra de inmediato, sin animación.
    const vh = window.innerHeight || document.documentElement.clientHeight;
    els.forEach((el) => {
      if (el.getBoundingClientRect().top < vh * 1.1) el.classList.add('is-visible');
    });
    document.documentElement.classList.add('cherry-anim');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0, rootMargin: '0px 0px 15% 0px' }
    );
    els.forEach((el) => { if (!el.classList.contains('is-visible')) observer.observe(el); });
  };

  const setupHeaderShrink = () => {
    const top = document.querySelector('[data-cherry-header]');
    if (!top) return;
    let last = window.scrollY;
    const update = () => {
      const y = window.scrollY;
      top.classList.toggle('is-scrolled', y > 12);
      top.classList.toggle('is-hidden', y > last && y > 240);
      last = y;
    };
    window.addEventListener('scroll', update, { passive: true });
    update();
  };

  const setupMobileDrawer = () => {
    const drawer = document.querySelector('[data-cherry-drawer]');
    if (!drawer) return;
    const opens = document.querySelectorAll('[data-cherry-drawer-open]');
    const closes = document.querySelectorAll('[data-cherry-drawer-close]');
    const open = () => {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    };
    const close = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    };
    opens.forEach((b) => b.addEventListener('click', open));
    closes.forEach((b) => b.addEventListener('click', close));
    drawer.addEventListener('click', (e) => {
      if (e.target === drawer) close();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  };

  const setupCartCountUpdates = () => {
    const counter = document.querySelector('[data-cherry-cart-count]');
    if (!counter) return;
    document.addEventListener('cart:updated', (e) => {
      const count = e.detail?.cart?.item_count;
      if (typeof count === 'number') counter.textContent = count;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
